export default "__VITE_ASSET__DjNI6f3z__"